import { Col, Row } from 'antd'
import { FC, useState } from 'react'

import { useAppSelector } from '../../../../../app/hook'
import { formatNumber } from '../../../../../util/formatNumber'
import { getComparedText } from '../../../../../util/getComparedText'
import { StatisticModal } from './StatisticModal'
import { StatisticsBox } from './StatisticsBox'
import Styles from './StatisticsBox.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    performance: performanceRequestData
}

export interface dataType {
    label1: string
    id?: number
    label2: string
    performance: string | number
    badge?: string
    size?: string
    compared?: string
    coin?: string
    actualperformance: number
    description?: string
}
export const StatisticsBoxes: FC<Props> = ({ performance }) => {
    const { t } = useTranslation()
    const { user } = useAppSelector((state) => state.profile)
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const [selected, setSelected] = useState<dataType>()

    const onStatisticHandler = (data: dataType) => {
        setIsModalOpen(true)
        setSelected(data)
    }

    const DATA = [
        {
            label1: t('txt_all_time'),
            id: 1,
            label2: '%PNL',
            performance:
                formatNumber(
                    performance.since_inception_pct,
                    false,
                    true,
                    false
                ) + '%',
            badge: performance.since_inception_pct_badge_level,
            size: 'big',
            compared: getComparedText(
                +performance.since_inception_pct_percentile?.toFixed(2)
            ),
            actualperformance: performance.since_inception_pct,
        },
        {
            label1: t('txt_longest'),
            id: 2,
            label2: t('txt_winning_streak'),
            badge: performance.winning_streak_days_longest_badge_level,
            performance: performance.winning_streak_days_longest,
            size: 'big',
            compared: getComparedText(
                +performance.winning_streak_days_longest_percentile?.toFixed(2)
            ),
            actualperformance: performance.winning_streak_days_longest,
            description: t('txt_wins_refers'),
        },
        {
            label1: t('txt_highest_daily'),
            id: 3,
            label2: `'% ${t('txt_gain')}'`,
            badge: performance.highest_daily_PL_pct_badge_level,
            performance:
                formatNumber(
                    performance.highest_daily_PL_pct,
                    false,
                    true,
                    false
                ) + '%',
            compared: getComparedText(
                +performance.highest_daily_PL_pct_percentile?.toFixed(2)
            ),
            actualperformance: performance.highest_daily_PL_pct,
        },
        {
            label1: t('txt_highest_daily'),
            id: 4,
            label2: t('txt_volume'),
            badge: performance.highest_daily_volume_badge_level,
            //TODO:
            coin: 'USDS',
            performance: formatNumber(
                performance.highest_daily_volume,
                true,
                false,
                false
            ),
            compared: getComparedText(
                +performance.highest_daily_volume_percentile?.toFixed(2)
            ),
            actualperformance: performance.highest_daily_volume,
        },
        {
            label1: t('txt_volume_traded'),
            label2: t('txt_this_week'),
            id: 5,
            badge: performance.weekly_volume_badge_level,
            //TODO:
            coin: 'USDS',
            performance: formatNumber(
                performance.weekly_volume_online,
                true,
                false,
                false
            ),
            compared: getComparedText(
                +performance.weekly_volume_percentile?.toFixed(2)
            ),
            actualperformance: performance.weekly_volume_online,
        },

        {
            label1: '%PNL',
            label2: t('txt_this_week'),
            id: 6,
            badge: performance.weekly_PL_pct_badge_level,
            performance:
                formatNumber(
                    performance.weekly_PL_pct_online,
                    false,
                    true,
                    false
                ) + '%',
            compared: getComparedText(
                performance.weekly_PL_pct_percentile?.toFixed(2)
            ),

            actualperformance: performance.weekly_PL_pct_online,
        },
    ]

    const isUserOwnAccount =
        window?.localStorage.getItem('MOCK_ACC_ID') &&
        window?.localStorage.getItem('MOCK_ACC_ID') ===
            user?.additional_user_info?.accountId?.toString()
            ? true
            : false
    return (
        <>
            <StatisticModal
                userData={user}
                isModalOpen={isModalOpen}
                onCLoseModal={() => setIsModalOpen(false)}
                data={selected}
            />
            <Row justify="space-between" gutter={[7, 8]}>
                {DATA.map((data) => {
                    return (
                        <Col
                            key={data.id}
                            span={12}
                            className={Styles.statisticsBoxes}
                        >
                            <StatisticsBox
                                onClick={() =>
                                    isUserOwnAccount && onStatisticHandler(data)
                                }
                                label1={data.label1}
                                label2={data.label2}
                                badge={data.badge}
                                coin={data.coin}
                                performance={data.performance}
                                compared={data.compared}
                                actualperformance={data.actualperformance}
                            />
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}
